import { render, staticRenderFns } from "./sendDateEdit.vue?vue&type=template&id=a8922918&scoped=true&"
import script from "./sendDateEdit.vue?vue&type=script&lang=js&"
export * from "./sendDateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8922918",
  null
  
)

export default component.exports